import {createSelector} from "reselect";


export const getContractObjectSelector = (state, props) => {
    if (state.objects && state.objects.objects) {
        return state.objects.objects[props.match.params.contractId]
    }
}


export const getCitiesList = (state) => {
    return state.contractsDetailPage.citiesList
}


export const getCitiesListReversed = createSelector(getCitiesList, (citiesList) => {
    if (!citiesList) {
        return
    }

    return Object.entries(citiesList).reduce((acc, cur) => {
        return {...acc, [cur[1]]: cur[0]}
    }, {})


})